import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSwitch, FlexBox, Icon, Text, Tooltip, } from '@dixa/lib-shared-habla';
/** Represents a toggle switch for enabling/disabling an instagram feature. */
export const InstagramFeatureToggle = ({ input, inputLabel, tooltipLabel, }) => {
    return (_jsxs(FlexBox, Object.assign({ gap: "200" }, { children: [_jsx(FieldSwitch, { input: input }), _jsx(Text.Paragraph, { children: inputLabel }), _jsx(Tooltip, Object.assign({ content: tooltipLabel, wrap: "div", wrapProps: { style: { display: 'flex' } } }, { children: _jsx(Icon, { name: "info" }) }))] })));
};
